(() => {
  const STORAGE_KEY = 'lcg-wishlist-v1';

  const countItems = () => {
    try {
      const items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(items) ? items.length : 0;
    } catch (error) {
      return 0;
    }
  };

  const syncCount = () => {
    const count = countItems();
    const hasItems = count > 0;
    document.querySelectorAll('[data-lcg-wishlist]').forEach((trigger) => {
      const badge = trigger.querySelector('[data-lcg-wishlist-count]');
      trigger.classList.toggle('has-items', hasItems);
      trigger.setAttribute(
        'aria-label',
        hasItems ? `Favoris, ${count}${window.CabaneI18n.pick(" produit"," product")}${count > 1 ? 's' : ''}` : window.CabaneI18n.pick("Favoris","wishlist")
      );
      if (badge) {
        badge.textContent = count > 99 ? '99+' : String(count);
        badge.hidden = !hasItems;
      }
    });
  };

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-lcg-wishlist]')) return;
    event.preventDefault();
    document.dispatchEvent(new CustomEvent('lcg:wishlist-open'));
  });
  document.addEventListener('lcg:wishlist-change', syncCount);
  document.addEventListener('shopify:section:load', syncCount);
  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) syncCount();
  });
  syncCount();
})();

(() => {
  if (window.__lcgChatVisibilityController) {
    window.__lcgChatVisibilityController.refresh();
    return;
  }

  const MOBILE_QUERY = '(max-width: 749px)';
  const SENSITIVE_SELECTOR = '#categories, [data-cabane-catalog-root] #product-grid';
  const BUYBAR_SELECTOR = 'body.template-product [data-cabane-mobile-buybar]';
  const ROOT_CLASS = 'lcg-chat-sensitive';
  const mobileMedia = window.matchMedia(MOBILE_QUERY);
  const root = document.documentElement;
  let intersectionObserver;
  let contentObserver;
  let buybarObserver;
  let frameId;

  const intersectsViewport = (element) => {
    const bounds = element.getBoundingClientRect();
    return bounds.width > 0
      && bounds.height > 0
      && bounds.bottom > 0
      && bounds.right > 0
      && bounds.top < window.innerHeight
      && bounds.left < window.innerWidth;
  };

  const update = () => {
    frameId = undefined;

    if (!mobileMedia.matches) {
      root.classList.remove(ROOT_CLASS);
      return;
    }

    const hasSensitiveContent = Array.from(document.querySelectorAll(SENSITIVE_SELECTOR)).some(intersectsViewport);
    const hasActiveBuybar = Array.from(document.querySelectorAll(BUYBAR_SELECTOR)).some(
      (buybar) => buybar.getAttribute('aria-hidden') !== 'true'
    );

    root.classList.toggle(ROOT_CLASS, hasSensitiveContent || hasActiveBuybar);
  };

  const scheduleUpdate = () => {
    if (frameId !== undefined) return;
    frameId = window.requestAnimationFrame(update);
  };

  const watchBuybars = () => {
    buybarObserver?.disconnect();
    buybarObserver = new MutationObserver(scheduleUpdate);
    document.querySelectorAll(BUYBAR_SELECTOR).forEach((buybar) => {
      buybarObserver.observe(buybar, {
        attributes: true,
        attributeFilter: ['aria-hidden', 'class', 'hidden']
      });
    });
  };

  const refresh = () => {
    intersectionObserver?.disconnect();

    if (mobileMedia.matches && 'IntersectionObserver' in window) {
      intersectionObserver = new IntersectionObserver(scheduleUpdate, { threshold: 0 });
      document.querySelectorAll(SENSITIVE_SELECTOR).forEach((element) => intersectionObserver.observe(element));
    }

    watchBuybars();
    scheduleUpdate();
  };

  const start = () => {
    refresh();
    contentObserver = new MutationObserver(refresh);
    contentObserver.observe(document.body, { childList: true, subtree: true });
  };

  window.__lcgChatVisibilityController = { refresh };

  if (typeof mobileMedia.addEventListener === 'function') {
    mobileMedia.addEventListener('change', refresh);
  } else {
    mobileMedia.addListener(refresh);
  }
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
